import { get, put, post, del } from '../../helpers/api_helper'
import { API_ENDPOINTS } from '../constants'

class ApiService {
  // User Profile
  static getUserProfile = () => get(API_ENDPOINTS.USER.PROFILE)
  static updateUserProfile = (data) => put(API_ENDPOINTS.USER.PROFILE, data)
  
  // Curriculum
  static getCurriculum = () => get(API_ENDPOINTS.CURRICULUM.BASE)
  static updateCurriculum = (data) => put(API_ENDPOINTS.CURRICULUM.BASE, data)
  static deleteCurriculum = () => del(API_ENDPOINTS.CURRICULUM.BASE)

  // Candidates
  static listCandidates = () => get(API_ENDPOINTS.CANDIDATES.LIST)
  static getCandidateDetail = (id) => get(`${API_ENDPOINTS.CANDIDATES.DETAIL}/${id}`)
  static deleteCandidate = (id) => del(`${API_ENDPOINTS.CANDIDATES.DETAIL}/${id}`)

  // Admin
  static listCognitoUsers = () => get(API_ENDPOINTS.ADMIN.USERS)
  static listCognitoGroups = () => get(API_ENDPOINTS.ADMIN.GROUPS)
  static setUserGroups = (username, groups) => put(`${API_ENDPOINTS.ADMIN.USERS}/${encodeURIComponent(username)}/groups`, { groups })
  static createUser = (data) => post(API_ENDPOINTS.ADMIN.USERS, data)
  static setUserTemporaryPassword = (username, password) =>
    put(`${API_ENDPOINTS.ADMIN.USERS}/${encodeURIComponent(username)}/password`, { password })
  static deleteCognitoUser = (username) =>
    del(`${API_ENDPOINTS.ADMIN.USERS}/${encodeURIComponent(username)}`)
  static resendUserInvite = (username) =>
    post(`${API_ENDPOINTS.ADMIN.USERS}/${encodeURIComponent(username)}/resend-invite`, {})
  static getAdminMetrics = ({ weeks = 12, days = 30 } = {}) =>
    get(`${API_ENDPOINTS.ADMIN.METRICS}?weeks=${weeks}&days=${days}`)
  
  // Generic CRUD operations
  static create = (endpoint, data) => post(endpoint, data)
  static read = (endpoint) => get(endpoint)
  static update = (endpoint, data) => put(endpoint, data)
  static delete = (endpoint) => del(endpoint)
}

export default ApiService